// DEF-1: menschenlesbarer Titel-Vorschlag aus dem Lauf-Kontext (deutscher Inhalt, kein UI-String).
// #208: nach shared verschoben, damit der Defect-Dialog zu einem Schritt (Web) denselben Titel
// vorbelegt wie der Auto-Defect der API — eine Quelle statt zwei Kopien.
export function buildAutoDefectTitle(input: {
  testCaseHumanId: string | null;
  stepNo: number | null;
  tcode: string | null;
}): string {
  const tc = input.testCaseHumanId ?? '?';
  let title = `Fehler in ${tc}`;
  if (input.stepNo !== null) title += ` — Schritt ${input.stepNo}`;
  if (input.tcode) title += ` (${input.tcode})`;
  return title;
}
